import { Avatar, Card, Divider, Group, Stack, Text } from "@mantine/core"
import { IconLock } from "@tabler/icons-react"
import { StatusBadge } from "../../../../../-components/status-badge"
import { RoleCastListItem } from "../../../../../../../@client/Theasoft_ApiServer_Roles"
import { PersonLinks } from "./person-links"
import { RoleLink } from "./role-link"
import { GroupedSimpleGrid } from "../../../../../-components/grouped-simple-grid"
import { ScrollContainer } from "../../../../../../../-components/scroll-container"
import { PersonProfilePictureAvatar } from "../../../../../-components/person-profile-picture-avatar"
import { Suspense } from "react"
import { useSuspenseQueryGet } from "../../../../../../../typed-client/hooks/use-suspense-query-get"

interface Props {
  activityId: number
  ownerGroups: string[]
}

export function CastsCards({ activityId, ownerGroups }: Props) {
  const { data: productionCasts } = useSuspenseQueryGet(
    "/api/Role/GetRoleCastListGroupedByOwner",
    {
      activityId,
      ownerGroups,
    }
  )

  return (
    productionCasts && (
      <ScrollContainer direction={"column"}>
        <Stack>
          {productionCasts
            .filter((p) => p.roleCastsGroupedByOwner.length > 0)
            .map((production, i) => (
              <Stack key={i}>
                {production.title && (
                  <>
                    <Divider />
                    <Text fz={"xl"} fw={"bold"}>
                      {production.title}
                    </Text>
                  </>
                )}
                <GroupedSimpleGrid
                  groupedItems={production.roleCastsGroupedByOwner.map((v) => [
                    v.owner,
                    v.casts,
                  ])}
                  renderItem={(item) => (
                    <CastCard key={item.roleId} cast={item} />
                  )}
                />
              </Stack>
            ))}
        </Stack>
      </ScrollContainer>
    )
  )
}

interface CastCardProps {
  cast: RoleCastListItem
}
function CastCard({
  cast: { role, casts, timePeriod, status, isSecret, roleId, productionId },
}: CastCardProps) {
  return (
    <Card shadow="xs">
      <Stack gap={"xs"}>
        <Group wrap="nowrap">
          <Avatar.Group spacing={"md"}>
            {casts.slice(0, 4).map((person) => (
              <Suspense key={person.personId} fallback={<Avatar />}>
                <PersonProfilePictureAvatar personId={person.personId} />
              </Suspense>
            ))}
          </Avatar.Group>
          <Group>
            <RoleLink
              lineClamp={2}
              truncate="end"
              fw={"bold"}
              roleId={roleId}
              productionId={productionId}
              name={role}
              style={{ whiteSpace: "wrap" }}
            />
            <Group>
              {isSecret && <IconLock />}
              <StatusBadge status={status} />
            </Group>
          </Group>
        </Group>
        {casts && (
          <>
            <Group gap={2}>
              <PersonLinks persons={casts} />
            </Group>
            <Text>{timePeriod}</Text>
          </>
        )}
      </Stack>
    </Card>
  )
}
